import { Box } from "@chakra-ui/react";
import { Fragment, type FC } from "react";
import { splitTextForSearchHighlighting } from "../../../utils/textUtils";

type HighlightedSearchTextProps = {
  text?: string;
  query: string;
  highlightSnippet?: string;
};

/**
 * Renders `text` with search hits emphasized.
 */
const HighlightedSearchText: FC<HighlightedSearchTextProps> = ({
  text,
  query,
  highlightSnippet,
}) => {
  const segments = splitTextForSearchHighlighting(text ?? "", query, highlightSnippet);
  return (
    <>
      {segments.map((s, i) =>
        s.highlight ? (
          <Box
            as="mark"
            key={i}
            bg="yellow.200"
            display="inline"
            px={0}
            lineHeight="inherit"
          >
            {s.text}
          </Box>
        ) : (
          <Fragment key={i}>{s.text}</Fragment>
        ),
      )}
    </>
  );
};

export default HighlightedSearchText;
